import React from 'react'
import {Link} from "react-router-dom"
import "./styles.css"

interface Img {
  img:string
}

export const BannerProductImg:React.FC<Img> = ({img}) => {
  return (
    <Link className="bannerImg" to="#" ><img  src={img}/></Link>
  )
}
export default BannerProductImg